import * as React from 'react'
import {veboxDefaultTheme} from "../index";
import {HashRouter, Route, Routes} from "react-router-dom";
import {ThemeProvider} from "@vebox/etui-system";
import './styles.scss'
import {CensusMenu} from "./widgets/CensusMenu";
import {CensusListProvider} from "./providers/CensusListProvider";
import {CENSUS_DETAILS_PAGE, CensusDetails} from "./pages/CensusDetails";
import {CensusCooler} from "../processes/massive_actions/CensusCooler";
import {VeboxUser} from '../providers/VeboxUser';
import {isCensusAvailable} from "../processes/massive_actions/MassiveActionsController";
import {DataResponse} from "../processes/massive_actions/CensusCooler/data/models/RestApi";
import {
    JSONCensusAvailabilityCheckResult
} from "../processes/massive_actions/CensusCooler/data/models/JSONCensusAvailabilityCheckResult";
import {CensusDetailsProvider} from "./providers/CensusDetailsProvider";
import {Display} from "../components/Display";
import {ClosedLevelTab} from "./components/ClosedLevelTab";
import {DetailDashboard} from "./widgets/DetailDashboard";
import {JSONCensus} from "../processes/massive_actions/CensusCooler/data/models/JSONCensus";
import {Section} from "../processes/massive_actions/CensusCooler/pages/CensusStatusPage/types";

interface CensusCoolerHistoryListProps {
    stackManager: any;
}


export interface LastUserPosition {
    census?: JSONCensus;
    openedSection?: Section[]
    detailPage?: CENSUS_DETAILS_PAGE
}

export const CensusCoolerHistoryList: React.FC<CensusCoolerHistoryListProps> = ({stackManager}) => {
    const [isCensusFeatureAvailable, setIsCensusFeatureAvailable] = React.useState<DataResponse<JSONCensusAvailabilityCheckResult>>(
        {isLoading: true});
    const [location, setLocation] = React.useState<Location>();
    const [isLevelOpen, setIsLevelOpen] = React.useState<boolean>(true);
    const [navigateToCensusDetail, setNavigateToCensusDetail] = React.useState<boolean>(false);
    const [lastUIUserPosition, setLastUIUserPosition] = React.useState<LastUserPosition>();

    const updateNavigateToCensusDetail = (value: boolean) => {
        setNavigateToCensusDetail(value)
        if (!value) {
            updateLastUserPosition(undefined, true)
        }
    }

    const updateLastUserPosition = (userPosition: LastUserPosition, replace?: boolean) => {
        if (replace) {
            setLastUIUserPosition(userPosition);
        } else {
            setLastUIUserPosition({...lastUIUserPosition, ...userPosition});
        }
    }

    React.useEffect(() => {
        if (location && location?.pathname === "/") {
            isCensusAvailable()
                .then((isCensusAvailable) => {
                    setIsCensusFeatureAvailable({isLoading: false, data: isCensusAvailable});
                })
                .catch((error) => {
                    console.error(error);
                    setIsCensusFeatureAvailable({isLoading: false, error});
                })
        }
    }, [location]);


    const updateOpenLevel = (open: boolean) => {
        setIsLevelOpen(open)
    }

    return (
        <ThemeProvider theme={veboxDefaultTheme}>
            <Display isVisible={isLevelOpen}>
                <VeboxUser.Provider>
                    <HashRouter basename={"/"}>
                        <div className={"flx-row fill-parent"}>
                            <CensusListProvider>
                                <CensusMenu
                                    setLocation={setLocation}
                                    isCensusFeatureAvailable={isCensusFeatureAvailable}
                                    updateNavigateToCensusDetail={updateNavigateToCensusDetail}
                                />
                            </CensusListProvider>
                            <div className={"fill-parent"}>
                                <Routes>
                                    <Route
                                        path={"/"}
                                        element={
                                            // Census dashboard*
                                            <DetailDashboard
                                                navigateToCensusDetail={navigateToCensusDetail}
                                                lastVisitedCensus={lastUIUserPosition?.census}
                                                updateNavigateToCensusDetail={updateNavigateToCensusDetail}
                                            />
                                        }
                                    />
                                    <Route
                                        path={"/:censusGuid"}
                                        element={
                                            // Census details
                                            <CensusDetailsProvider
                                                stackManager={stackManager}
                                                updateLastUserPosition={updateLastUserPosition}
                                                lastUIUserPosition={lastUIUserPosition}
                                                updateOpenLevel={updateOpenLevel}
                                                updateNavigateToCensusDetail={updateNavigateToCensusDetail}
                                            >
                                                <CensusDetails/>
                                            </CensusDetailsProvider>
                                        }
                                    />
                                    <Route
                                        path={"/newCensus"}
                                        element={
                                            // Census details
                                            <CensusCooler
                                                fromCensusHistory={true}
                                                isCensusFeatureAvailable={isCensusFeatureAvailable}
                                            />
                                        }
                                    />
                                </Routes>
                            </div>
                        </div>
                    </HashRouter>
                </VeboxUser.Provider>
            </Display>
            <Display isVisible={!isLevelOpen}>
                <ClosedLevelTab
                    lastVisitedCensus={lastUIUserPosition?.census}
                    stackManager={stackManager}
                    updateOpenLevel={updateOpenLevel}
                />
            </Display>
        </ThemeProvider>
    )
}